/*=============================================== RatingPage ===============================================*/

import { useState } from "react"
import { Rating } from "tsx-library-julseb"

import { ComponentsLayout } from "components"
import type { ItemType, PropsItemType } from "components"

import { commonProps, iconBoxicon } from "data"

const RatingPage = () => {
    const [ratingStar, setRatingStar] = useState<number>(1)
    const [ratingHeart, setRatingHeart] = useState<number>(2)

    const items: ItemType[] = [
        {
            title: "Default icons",
            content: <Rating rating={ratingStar} setRating={setRatingStar} />,
            code: "const [ratingStar, setRatingStar] = useState(1)\n\n<Rating rating={ratingStar} setRating={setRatingStar} />",
            codeTs: "const [ratingStar, setRatingStar] = useState<number>(1)\n\n<Rating rating={ratingStar} setRating={setRatingStar} />",
        },
        {
            title: "Custom icons",
            intro: "",
            content: (
                <Rating
                    rating={ratingHeart}
                    setRating={setRatingHeart}
                    icons={{ default: "heart", checked: "heart-full" }}
                />
            ),
            code: 'const [ratingHeart, setRatingHeart] = useState(2)\n\n<Rating rating={ratingHeart} setRating={setRatingHeart} icons={{ default: "heart", checked: "heart-full" }} />',
            codeTs: 'const [ratingHeart, setRatingHeart] = useState<number>(2)\n\n<Rating rating={ratingHeart} setRating={setRatingHeart} icons={{ default: "heart", checked: "heart-full" }} />',
        },
    ]

    const propsItems: PropsItemType[] = [
        {
            subtitle: "rating",
            type: "number",
            required: true,
        },
        {
            subtitle: "setRating",
            intro: (
                <>
                    This is required if <code>readOnly</code> is either{" "}
                    <code>undefined</code> or set to <code>false</code>.
                </>
            ),
            type: "function",
        },
        {
            subtitle: "readOnly",
            intro: (
                <>
                    This is required if <code>setRating</code> is{" "}
                    <code>undefined</code>.
                </>
            ),
            type: "boolean",
        },
        "separator",
        {
            subtitle: "icons",
            intro: "If this is defined, both icons are required.",
            type: "object",
        },
        {
            title: (
                <>
                    <code>icons</code> object
                </>
            ),
            subtitle: "default",
            intro: commonProps.addIconCapital,
            type: "string",
            default: <>{iconBoxicon("star")} (regular)</>,
        },
        {
            subtitle: "checked",
            type: "string",
            default: <>{iconBoxicon("star")} (solid)</>,
        },
    ]

    return <ComponentsLayout items={items} propsItems={propsItems} />
}

export default RatingPage
